export default __webpack_public_path__ + "static/media/monitor.94538b31.svg";